<template>
    <div>
        <template v-if="!formLoading && form">
            <v-snackbar :color="snackbarColor" v-model="snackbarValue" top>
                {{ snackbarText }}
                <template v-slot:action>
                    <v-icon @click="hideSnackbar">mdi-close</v-icon>
                </template>
            </v-snackbar>
            <v-container v-if="form.header_image" fluid :style="`background: #f2f4f5`"
                         :class="$vuetify.breakpoint.smAndDown ?'pa-0' : 'py-0'">
                <v-row justify="center" no-gutters>
                    <v-col cols="12" md="10" lg="8" xl="6" class="pa-0">
                        <v-img :src="form.header_image"/>
                    </v-col>
                </v-row>
            </v-container>
            <v-container fluid>
                <v-row justify="center">
                    <v-col cols="12" md="10" lg="8" xl="6">
                        <v-card elevation="0">
                            <v-card-text class="pa-0" v-html="form.register_description">
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="form.register_open">
                    <v-col cols="12" md="10" lg="8" xl="6">
                        <v-card v-if="form">
                            <v-toolbar color="primary" :dark="dark" style="height: auto !important;min-height: 64px !important;">
                                <v-toolbar-title v-html="form.register_heading ? form.register_heading : $t('login.heading')">
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-form
                                        ref="form"
                                        v-model="valid"
                                        @submit.stop="createFormResultFromForm"
                                        onSubmit="return false;"
                                >
                                    <password-field v-if="form.password_type!=='none'" v-model="password"
                                                    :error="validationErrors.password"
                                                    @input="delete validationErrors.password"></password-field>
                                    <template v-for="(formField, idx) in form.formFields">
                                        <component :is="`${formField.type}Field`" v-bind="formField.data" :key="idx"
                                                   v-model="results[formField.id]"></component>
                                    </template>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="createFormResultFromForm" :class="dark ? 'white--text' : ''"
                                       :loading="sending">
                                    {{ form.register_button_label ? form.register_button_label : $t('login.button_label') }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <template v-if="form.sponsors_in_register && form.sponsors.length>0">
                    <v-row justify="center">
                        <v-col cols="12" md="10" lg="8" xl="6">
                            <div class="text-subtitle-1 mt-6">{{ form.sponsor_heading ? form.sponsor_heading : $t('foyer.sponsor_heading')
                                }}
                            </div>
                            <v-row align="stretch">
                                <v-col v-for="(sponsor, idx) in form.sponsors" :key="idx" cols="12" sm="6" md="4"
                                       lg="3"
                                       xl="2">
                                    <sponsor :sponsor="sponsor"></sponsor>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </template>
            </v-container>
        </template>
    </div>
</template>

<script>
    import gql from 'graphql-tag';
    import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
    import CountryField from '@/components/Form/CountryField';
    import EmailField from '@/components/Form/EmailField';
    import GenericCheckboxField from '@/components/Form/GenericCheckboxField';
    import GenericSelectField from '@/components/Form/GenericSelectField';
    import GenericTextField from '@/components/Form/GenericTextField';
    import NameField from '@/components/Form/NameField';
    import EFNField from '@/components/Form/EFNField';
    import { AUTH_TOKEN, onLogin } from '@/vue-apollo';
    import PasswordField from '@/components/Form/PasswordField';
    import router from '@/router';
    import snackbar from '@/mixins/snackbar';
    import Sponsor from '@/components/Sponsor';
    import { errorKind } from '@/errors';


    export default {
        name: 'Login',
        props: {
            url: String,
        },
        mixins: [
            snackbar,
        ],
        data: () => ( {
            results: {},
            validationErrors: {},
            valid: true,
            password: null,
            generalError: false,
            sending: false,
        } ),
        components: {
            Sponsor,
            PasswordField,
            CountryField,
            EmailField,
            GenericCheckboxField,
            GenericSelectField,
            GenericTextField,
            NameField,
            EFNField,
        },
        mounted ()
        {
          if(this.$route.query.p) {
            this.createFormResultFromParam()
          }
            let url = this.url;
            this.setFormLoading(true)
            if(localStorage.getItem(AUTH_TOKEN)) {
                this.$router.push( { name: 'Event', params: { url: router.history.current.params.url } } );
                return
            }
            this.$apollo.query( {
                query: gql`
                    query eventsForm($url: String!){
                        eventsForm(url: $url) {
                            id
                            formFields {
                                id
                                type
                                data
                            }
                            sponsors {
                                name
                                id
                                link
                                file
                                description
                                advanced
                                contacts_heading
                                downloads_heading
                                contacts {
                                    text
                                    heading
                                }
                                downloads {
                                    name
                                    file
                                }
                            }
                            docCheckLogin {
                                id
                            }
                            language
                            title
                            register_heading
                            register_description
                            register_button_label
                            sponsors_in_register
                            sponsor_heading
                            register_open
                            password_type
                            logo
                            primary_color
                            header_image
                        }
                }`,
                variables: {
                    url: url,
                },
              fetchPolicy: "network-only"
            } ).then( ( { data } ) =>
            {
                if ( data )
                {
                  this.setFormLoading(false)
                  if(data.eventsForm.docCheckLogin) {
                    if(!localStorage.getItem(`${AUTH_TOKEN}_doc_check`)) {
                        this.$router.push( { name: 'DocCheck', params: { url: this.$route.params.url } } );
                        return
                    }
                  }
                    if ( data.eventsForm.formFields && data.eventsForm.formFields.length > 0 || data.eventsForm.password_type !== 'none' || !data.eventsForm.register_open )
                    {
                        this.updateForm( data.eventsForm );
                    }
                    else
                    {
                        this.$apollo.mutate( {
                            // Query
                            mutation: gql`mutation ($event_id: ID!) {
                                visit(event_id: $event_id)
                              }`,
                            variables: {
                                event_id: data.eventsForm.id,
                            },
                        } ).then( async ( data ) =>
                        {
                            // Result
                            await onLogin( this.$apollo.getClient(), data.data.visit );
                            await this.$router.push( { name: 'Foyer', params: router.history.current.params } );
                        } ).catch( ( error ) =>
                        {
                            // The snackbar only renders once the form is set
                            this.updateForm( data.eventsForm );
                            let { graphQLErrors } = error;
                            if ( graphQLErrors && graphQLErrors.length > 0 && errorKind( graphQLErrors[ 0 ] ) === 'generic' )
                            {
                                this.showErrorSnackbar( graphQLErrors[ 0 ].message );
                            }
                            else
                            {
                                this.showGeneralErrorSnackbar();
                            }
                        } );
                    }
                }
            } );
        },
        methods: {
            ...mapActions( ['updateForm'] ),
            ...mapMutations( ['setFormLoading'] ),
          createFormResult (createFormResultInput)
          {

              this.$apollo.mutate( {
                // Query
                mutation: gql`mutation ($createFormResultInput: CreateFormResultInput!) {
                                createFormResult(input: $createFormResultInput)
                              }`,
                variables: {
                  createFormResultInput: createFormResultInput,
                },
              } ).then( async ( data ) =>
              {
                // Result
                await onLogin( this.$apollo.getClient(), data.data.createFormResult );
                await this.$router.push( { name: 'Foyer', params: router.history.current.params } );
              } ).catch( ( error ) =>
              {
                // Error
                this.sending = false;
                let { graphQLErrors } = error;
                if ( graphQLErrors && graphQLErrors.length > 0 && errorKind( graphQLErrors[ 0 ] ) === 'validation' )
                {
                  this.showErrorSnackbar( this.$t('login.messages.error') );
                  this._.forEach( graphQLErrors[ 0 ].extensions.validation, ( fieldValidation, index ) =>
                  {
                    let parsedIndex = index.replace( 'input.', '' );
                    parsedIndex = parsedIndex.replace( /update./g, '' );
                    parsedIndex = parsedIndex.replace( /create./g, '' );
                    this.$set( this.validationErrors, parsedIndex, fieldValidation[ 0 ] );
                  } );
                }
                else
                {
                  this.showGeneralErrorSnackbar();
                }
              } );
          },
            createFormResultFromForm ()
            {
                if ( this.$refs.form.validate() )
                {
                    this.sending = true;
                    let createFormResultInput = {
                        event_id: this.form.id,
                        password: this.password,
                        formResultFields: [],
                    };
                    this._.forEach( this.form.formFields, ( formField ) =>
                    {
                        createFormResultInput.formResultFields.push(
                            {
                                form_field_id: formField.id,
                                value: this.results[ formField.id ],
                            },
                        );
                    } );
                    this.createFormResult(createFormResultInput)
                }
            },
          createFormResultFromParam()
          {
            let createFormResultInput = {
              event_id: this.frame.id,
              password: this.$route.query.p,
              formResultFields: [],
            };
            this.createFormResult(createFormResultInput)
          }
        },
        computed: {
            ...mapState( ['form', 'formLoading', 'frame'] ),
            ...mapGetters( ['dark'] ),
        },
    };
</script>

<style scoped>

    >>>.v-toolbar__content{
        height: auto !important;
        min-height: 64px !important;
    }

</style>